import { PieChart, Pie, Cell, Legend, Tooltip } from 'recharts';
import { NationalityModel } from '../../../../types/indicators.interfaces';
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from 'react';

const COLORS = {
  national: '#0C1B7A',
  america: '#c278ff',
  europe: '#48B5E4',
  asia: '#E1897F',
  africa: '#FAD046',
  oceania: '#24A49B',
}; // Colors for Sale and Rent

const ZonePopulationChart = (data: NationalityModel) => {
  const [chartData, setChartData] = useState<any>([]);
  useEffect(() => {
    const chartData = Object.entries(data).map(([key, value]) => {
      if (!value || Number(value) < 1) {
        return;
      }
      return { name: <FormattedMessage id={key} />, value: value };
    });
    const filteredChartData = chartData.filter((item) => item !== undefined);
    setChartData(filteredChartData);
  }, [data]);

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    value,
    index,
  }: {
    cx: number;
    cy: number;
    midAngle: number;
    innerRadius: number;
    outerRadius: number;
    percent: number;
    value: number;
    index: number;
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 1.6;
    const x = cx + radius * Math.cos((-midAngle * Math.PI) / 180);
    const y = cy + radius * Math.sin((-midAngle * Math.PI) / 180);

    const key = chartData.find(
      (item: { name: string; value: number }) => item && value === item.value
    )?.name.props.id;

    const color = COLORS[key as keyof typeof COLORS];

    return (
      <>
        {value && key && color && (
          <text
            x={x}
            y={y}
            fill="#000"
            textAnchor={x > cx ? 'start' : 'end'}
            dominantBaseline="central"
            fontSize={12}
            fontFamily="Roboto, sans-serif"
            color={color}
          >
            {`${value?.toFixed(0)}%`}
          </text>
        )}
      </>
    );
  };
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        paddingRight: '30px',
      }}
    >
      <PieChart width={320} height={160}>
        <Pie
          data={chartData}
          cx="35%"
          cy="50%"
          isAnimationActive={false}
          innerRadius={50}
          outerRadius={60}
          paddingAngle={2}
          dataKey="value"
          label={renderCustomizedLabel}
          labelLine={false}
        >
          {chartData.map(
            (entry: { name: any; value: number }, index: number) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[entry.name.props.id as keyof typeof COLORS]}
              />
            )
          )}
        </Pie>
        <Tooltip
          formatter={(value: number, name: string) => [
            `${value.toFixed(1)}%`,
            name,
          ]}
        />
        <Legend
          layout="vertical"
          verticalAlign="middle"
          align="right"
          wrapperStyle={{ right: 0, fontSize: '12px' }}
        />
      </PieChart>
    </div>
  );
};

export default ZonePopulationChart;
